export default __webpack_public_path__ + "static/media/Inter-Medium.18b8c68e.ttf";